<template>
  <div class="list">
    <header-bar :isIndex="true"></header-bar>
    <div class="pt70 main">
      <section class="channel">
        <img src="@/assets/images/img/topic-icon.png" alt="话题"/>
        <div class="info">
          <h1>{{topicInfo.name}}</h1>
          <div class="info-count">
            <span class="artic-num-icon">文章<b>{{total}}</b></span>
          </div>
          <div class="info-des">
            <p>
              {{topicInfo.intro}}
            </p>
          </div>
        </div>
      </section>
    </div>
    <section class="main cl">
      <div class="main-left fl">
        <div class="content bg-white">
          <div
            class="news-list"
            v-infinite-scroll="getData"
            infinite-scroll-disabled="busy"
            infinite-scroll-distance="10"
          >
              <news-list v-for="(item, i) in articleDataList" :key="i" :dataList="item" :isTopic="true"></news-list>
            <div v-if="dataLoadNomore" class="loading-all">没有更多数据</div>
            <div v-else class="loading">正在加载中，请稍等…</div>
          </div>
        </div>
      </div>
      <div class="main-right fr">
        <com-foot></com-foot>
      </div>
    </section>
    <back-top></back-top>
  </div>
</template>

<script>
import HeaderBar from "@/components/Header.vue";
import NewsList from "@/components/NewsList.vue";
import ActivityList from "@/components/ActivityList.vue";
import infiniteScroll from "vue-infinite-scroll";
import BackTop from "@/components/BackTop.vue";
import ComFoot from "@/components/ComFoot.vue";
export default {
  name: "TopicList",
  directives: { infiniteScroll },
  components: {
    HeaderBar,
    NewsList,
    ActivityList,
    BackTop,
    ComFoot
  },
  data() {
    return {
      topicId: this.$route.params.id,
      topicInfo: {},
      articleDataList:[],
      type: 0,
      busy: false,
      dataLoadNomore: false,
      page: 1,
      size: 10,
      total: 0
    }
  },
  methods: {
    getData() {
      this.busy = true;
      this.$api.articleList({
          topicId: this.topicId,
          current: this.page,
          size: this.size,
          type: this.type,
        })
        .then((res) => {
          this.total = res.data.data.total;
          res.data.data.records.forEach((item, index) => {
            if (item.imgStr) {
              item.imgStr = item.imgStr.split(",");
            } else {
              item.imgStr = [];
            }
          });
          this.articleDataList = this.articleDataList.concat(
            res.data.data.records
          );
          if (res.data.data.current < res.data.data.pages) {
            this.page += 1;
            this.busy = false;
            this.dataLoadNomore = false;
          } else {
            this.dataLoadNomore = true;
          }
        });
    },
    getChannelDetail() {
      this.$api.topicDetail({
          id: this.topicId
        })
        .then((res) => {
          this.topicInfo = res.data.data
        });
    }
  },
  created() {
    this.getChannelDetail()
  },
};
</script>

<style scoped lang="scss">
.channel {
  padding: 30px 40px 30px 20px;
  background: url("../assets/images/channel_bg.png") center no-repeat;
  display: flex;
  img {
    width: 83px;
    height: 92px;
    margin-right: 21px;
  }
  .info {
    h1 {
      font-size: 20px;
      font-weight: 600;
      margin-bottom: 10px;
      line-height: 2;
    }
    .info-count {
      font-size: 15px;
      color: #333;
      margin-bottom: 15px;
      span {
        margin-right: 55px;
        padding-left: 20px;
        &:before {
          color: #b9b9b9;
          font-size: 17px;
          margin-right: 5px;
        }
        b {
          color: #121212;
          font-size: 18px;
          margin-left: 10px;
        }
      }
      .artic-num-icon {
          background: url('../assets/images/activity-num-icon.png') no-repeat left center;
        }
      .active-num-icon {
          background: url('../assets/images/artic-num-icon.png') no-repeat left center;
      }
    }
    .info-des {
      p {
        font-size: 15px;
        line-height: 24px;
      }
    }
  }
}
.main {
  width: 1000px;
  margin: 0 auto 10px;
  .main-left {
    width: 680px;
    .tab-bar {
      line-height: 2.5;
      padding: 10px 24px 0;
      border-bottom: 1px solid #efefef;
      li {
        float: left;
        margin-right: 50px;
        font-size: 18px;
        cursor: pointer;
        &.active {
          font-weight: bolder;
          border-bottom: 4px solid #317DFF;
          border-radius: 2px;
          color: #317DFF;
        }
      }
    }
    .loading {
      width: 680px;
      height: 52px;
      background: url("../assets/images/loading-icon.png") no-repeat 238px
        center;
      box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.07);
      font-size: 15px;
      font-weight: 400;
      color: #666666;
      border-top: 10px solid #f7f7f7;
      text-align: center;
      line-height: 42px;
    }
    .loading-all {
      width: 680px;
      height: 52px;
      box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.07);
      font-size: 15px;
      font-weight: 400;
      color: #666666;
      border-top: 10px solid #f7f7f7;
      text-align: center;
      line-height: 42px;
    }
  }
  .main-right {
    width: 310px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Topic.vue